/**
 * Niveau compatible entre une SKILLCARD et un élève (miroir de la fonction SQL
 * `card_level_compatible`, migration 0354 — garder synchro) : la carte a au
 * moins un niveau INFÉRIEUR OU ÉGAL à celui de l'élève. Carte sans niveau ou
 * élève sans niveau (étudiant) = compatible. MPSI = PTSI, MP = PT (même rang).
 */

const LEVEL_RANK: Record<string, number> = {
  '6e': 1,
  '5e': 2,
  '4e': 3,
  '3e': 4,
  '2nde': 5,
  '1re': 6,
  tle: 7,
  mpsi: 8,
  ptsi: 8,
  mp: 9,
  pt: 9,
};

export function schoolLevelRank(level: string | null | undefined): number | null {
  return level ? (LEVEL_RANK[level] ?? null) : null;
}

export function cardLevelCompatible(
  cardLevels: readonly string[] | null | undefined,
  studentLevel: string | null | undefined,
): boolean {
  const student = schoolLevelRank(studentLevel);
  if (student === null) return true;
  const ranks = (cardLevels ?? []).map(schoolLevelRank).filter((r): r is number => r !== null);
  if (ranks.length === 0) return true;
  return ranks.some((r) => r <= student);
}
